import { getFirestore, updateDoc, doc } from 'firebase/firestore';
import { collectionName } from './constants';

const updatePaymentGateway = async (id: string, values: any) => {
  updateDoc(doc(getFirestore(), collectionName, `${id}`), values);
};

export default updatePaymentGateway;
